export type WhatsAppTemplate = {
  id: string;
  element_name: string;
  data: string;
  params_count: number;
  parameter_positions: number[];
};

const FALLBACK_PREVIEW = "Selecione um template para visualizar a mensagem.";

export const parseTemplateContent = (
  content?: string,
  fallbackPreview = FALLBACK_PREVIEW,
) => {
  if (!content) return { message: fallbackPreview, ctaLabels: [] };

  const ctaSection = content.match(/(?:\s*\|\s*\[[^\]]+\])+\s*$/);
  const ctaLabels = ctaSection
    ? Array.from(ctaSection[0].matchAll(/\|\s*\[([^\]]+)\]/g), ([, label]) =>
        label.trim(),
      )
    : [];

  return {
    message: ctaSection
      ? content.slice(0, ctaSection.index).trimEnd()
      : content,
    ctaLabels,
  };
};

export const getTemplateParameterPositions = (
  template?: Pick<WhatsAppTemplate, "parameter_positions" | "params_count">,
): number[] => {
  if (!template) return [];
  if (template.parameter_positions.length > 0) {
    return template.parameter_positions;
  }

  return Array.from({ length: template.params_count }, (_, index) => index + 1);
};

export const createTemplatePreview = (
  template: WhatsAppTemplate | undefined,
  values: Record<number, string | undefined>,
  fallbackPreview?: string,
) => {
  const content = parseTemplateContent(template?.data, fallbackPreview);
  return {
    ...content,
    message: content.message.replace(/{{\s*(\d+)\s*}}/g, (_, raw) => {
      const position = Number(raw);
      return values[position] || `{{${position}}}`;
    }),
  };
};
